/**
 * Roles — §8.3.
 *
 * These mirror the backend's `RoleAssignment.role` values. Holding a role here
 * is only ever used to decide what to *render*; the server decides what is
 * *allowed*, independently, on every request (§8.4). Nothing in this file is a
 * security boundary.
 */

/**
 * ⚠️ **`event_organizer` was removed on 30 August 2026.** The product owner:
 * *"the system admin is the only allowed person to create an event"*, then
 * *"remove the organizer role from the system"*. The `/organize` portal is now
 * a `platform_admin` surface on both sides — `IsEventOrganizer` server-side
 * kept its name and changed what it requires.
 *
 * This list is the source of the `Role` union, so removing the member is what
 * makes `requiresRole: 'event_organizer'` a compile error rather than a
 * silently-never-true condition that hides a nav item forever.
 */
export const ROLES = [
  'learner',
  'instructor',
  'institution_admin',
  'moderator',
  'platform_admin',
] as const

export type Role = (typeof ROLES)[number]

export function isRole(value: string): value is Role {
  return (ROLES as readonly string[]).includes(value)
}
